export const getTestingAttributes = name => ({
    'data-e2e': name,
});
